const Config = {
  Server: {
    API_BASE_URL: process.env.REACT_APP_BASE_URL,
    iv: 'b3935ad5f9c8acca8e1485f14e29f68c',
    secretKey: 'ec34e0398015702ca9c136259c8bd0abca82a4754069af942c067ce03e5133e8'
  },
};

export default Config;
